var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input-container"},[_c('input',{staticClass:"blue-checkbox",attrs:{"id":_vm.$vnode.tag,"type":"checkbox"},on:{"change":$event => {
        _vm.$parent[_vm.field] = $event.target.checked;
        if (_vm.change) _vm.change($event.target.checked);
      }}}),_c('label',{attrs:{"for":_vm.$vnode.tag}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }